(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anipura-care-values"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reveal = (root = document) => {
      const nodes = root.querySelectorAll('[data-anipura-reveal]:not([data-reveal-ready])');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        nodes.forEach((node) => node.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      nodes.forEach((node) => {
        node.dataset.revealReady = 'true';
        observer.observe(node);
      });
    };
    reveal();
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anipura-client-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cloneSlide = (slide) => {
      const clone = slide.cloneNode(true);
      clone.dataset.videoClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('a,button,input,select,textarea,video').forEach((node) => node.setAttribute('tabindex', '-1'));
      return clone;
    };

    const hydrateVideo = (video) => {
      if (!video || video.dataset.videoHydrated) return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.videoHydrated = 'true';
      video.load();
    };

    const initVideos = (root) => {
      if (root.dataset.clientVideosReady) return;
      root.dataset.clientVideosReady = 'true';
      const track = root.querySelector('[data-video-track]');
      const viewport = root.querySelector('[data-video-viewport]');
      if (!track || !viewport) return;
      const originals = [...track.querySelectorAll(':scope > [data-video-slide]')];
      if (!originals.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrateVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '600px' });

      if (originals.length > 1) {
        const before = originals.map(cloneSlide);
        const after = originals.map(cloneSlide);
        track.prepend(...before);
        track.append(...after);
      }

      const allVideos = () => [...track.querySelectorAll('[data-client-video]')];
      allVideos().forEach((video) => observer.observe(video));

      const pauseOthers = (activeVideo) => {
        allVideos().forEach((video) => {
          if (video !== activeVideo && !video.paused) video.pause();
        });
      };

      track.querySelectorAll('[data-video-play]').forEach((button) => {
        button.addEventListener('click', async () => {
          const video = button.parentElement.querySelector('[data-client-video]');
          if (!video) return;
          hydrateVideo(video);
          pauseOthers(video);
          video.controls = true;
          try { await video.play(); } catch (error) { video.controls = false; }
        });
      });

      allVideos().forEach((video) => {
        const playButton = video.parentElement.querySelector('[data-video-play]');
        video.addEventListener('play', () => {
          pauseOthers(video);
          if (playButton) playButton.hidden = true;
        });
        video.addEventListener('ended', () => {
          video.controls = false;
          if (playButton) playButton.hidden = false;
        });
      });

      if (originals.length === 1) {
        root.querySelector('[data-video-previous]')?.setAttribute('hidden', '');
        root.querySelector('[data-video-next]')?.setAttribute('hidden', '');
        return;
      }

      let index = originals.length;
      let dragging = false;
      let pointerId;
      let dragStartX = 0;
      let dragOffset = 0;
      let wheelLocked = false;
      const gap = () => Number.parseFloat(getComputedStyle(track).gap) || 20;
      const step = () => originals[0].getBoundingClientRect().width + gap();
      const position = (animate = false, extraOffset = 0) => {
        track.classList.toggle('is-animating', animate);
        track.style.transform = `translate3d(${(-index * step()) + extraOffset}px,0,0)`;
      };
      const move = (delta) => {
        index += delta;
        position(true);
      };
      const normalize = () => {
        if (index >= originals.length * 2) index -= originals.length;
        if (index < originals.length) index += originals.length;
        position(false);
      };

      track.addEventListener('transitionend', normalize);
      root.querySelector('[data-video-previous]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-video-next]')?.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.target.closest('video,button,a,input,select')) return;
        dragging = true;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragOffset = 0;
        viewport.setPointerCapture(pointerId);
        track.classList.add('is-dragging');
        track.classList.remove('is-animating');
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        dragOffset = event.clientX - dragStartX;
        position(false, dragOffset);
      });
      const finishDrag = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (Math.abs(dragOffset) > 60) move(dragOffset < 0 ? 1 : -1);
        else position(true);
      };
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 12) return;
        event.preventDefault();
        if (wheelLocked) return;
        wheelLocked = true;
        move(event.deltaX > 0 ? 1 : -1);
        window.setTimeout(() => { wheelLocked = false; }, 360);
      }, { passive: false });
      window.addEventListener('resize', () => position(false));
      root.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('[data-video-block-id]');
        if (!selected) return;
        const originalIndex = originals.findIndex((slide) => slide.dataset.videoBlockId === selected.dataset.videoBlockId);
        if (originalIndex >= 0) { index = originals.length + originalIndex; position(true); }
      });
      position(false);
    };

    document.querySelectorAll('[data-anipura-client-videos]').forEach(initVideos);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-anipura-client-videos]').forEach(initVideos));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anipura-formula-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuiz = (quiz) => {
      if (quiz.dataset.quizReady) return;
      quiz.dataset.quizReady = 'true';
      const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
      const dots = [...quiz.querySelectorAll('[data-quiz-controls] .anipura-quiz__dots span')];
      const next = quiz.querySelector('[data-quiz-next]');
      const back = quiz.querySelector('[data-quiz-back]');
      const controls = quiz.querySelector('[data-quiz-controls]');
      const result = quiz.querySelector('[data-quiz-result]');
      const resultCards = [...quiz.querySelectorAll('[data-quiz-result-card]')];
      const resultMedia = [...quiz.querySelectorAll('[data-quiz-result-media]')];
      const defaultMedia = quiz.querySelector('[data-quiz-default-media]');
      const resultControls = quiz.querySelector('[data-quiz-result-controls]');
      const resultDots = resultControls ? [...resultControls.querySelectorAll('.anipura-quiz__dots span')] : [];
      const resultPrevious = quiz.querySelector('[data-result-previous]');
      const resultNext = quiz.querySelector('[data-result-next]');
      if (!steps.length || !next || !back || !result || !resultCards.length || !resultControls || !resultPrevious || !resultNext) return;
      let index = 0;
      let ranked = [];
      let resultSlide = 0;

      const render = () => {
        steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        back.disabled = index === 0;
        next.disabled = !steps[index].querySelector('input:checked');
      };

      const renderResult = () => {
        const productIndex = ranked[resultSlide].index;
        resultCards.forEach((card, cardIndex) => {
          card.hidden = cardIndex !== productIndex;
          const rank = card.querySelector('[data-quiz-result-rank]');
          if (rank) rank.textContent = `# ${resultSlide + 1}`;
        });
        resultMedia.forEach((media, mediaIndex) => { media.hidden = mediaIndex !== productIndex; });
        resultDots.forEach((dot, dotIndex) => {
          dot.hidden = dotIndex >= ranked.length;
          dot.classList.toggle('is-active', dotIndex === resultSlide);
        });
        resultPrevious.disabled = resultSlide === 0;
        resultNext.disabled = resultSlide === ranked.length - 1;
      };

      const showResult = () => {
        const totals = resultCards.map(() => 0);
        steps.forEach((step) => {
          const selected = step.querySelector('input:checked');
          if (!selected) return;
          selected.dataset.scores.split(',').forEach((score, scoreIndex) => {
            if (scoreIndex < totals.length) totals[scoreIndex] += Number.parseInt(score.trim(), 10) || 0;
          });
        });
        ranked = totals
          .map((score, productIndex) => ({ score, index: productIndex }))
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .slice(0, 3);
        resultSlide = 0;
        steps.forEach((step) => step.classList.remove('is-active'));
        if (defaultMedia) defaultMedia.hidden = true;
        controls.hidden = true;
        result.hidden = false;
        resultControls.hidden = false;
        quiz.querySelector('.anipura-quiz').classList.add('is-complete');
        renderResult();
      };

      steps.forEach((step) => step.addEventListener('change', () => { next.disabled = false; }));
      next.addEventListener('click', () => {
        if (index < steps.length - 1) {
          index += 1;
          render();
        } else {
          showResult();
        }
      });
      back.addEventListener('click', () => {
        if (index > 0) {
          index -= 1;
          render();
        }
      });
      resultPrevious.addEventListener('click', () => {
        if (resultSlide > 0) {
          resultSlide -= 1;
          renderResult();
        }
      });
      resultNext.addEventListener('click', () => {
        if (resultSlide < ranked.length - 1) {
          resultSlide += 1;
          renderResult();
        }
      });
      render();
    };
    document.querySelectorAll('[data-anipura-quiz]').forEach(initQuiz);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-anipura-quiz]').forEach(initQuiz));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anipura-loved-by-pet-parents"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLoved = (root) => {
      if (root.dataset.lovedReady) return;
      root.dataset.lovedReady = 'true';
      const slides = [...root.querySelectorAll('[data-loved-slide]')];
      const dots = [...root.querySelectorAll('[data-loved-dot]')];
      let activeIndex = 0;
      const show = (nextIndex) => {
        if (!slides.length) return;
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      root.querySelector('[data-loved-previous]')?.addEventListener('click', () => show(activeIndex - 1));
      root.querySelector('[data-loved-next]')?.addEventListener('click', () => show(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      root.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-loved-slide]');
        if (slide) show(Number.parseInt(slide.dataset.lovedIndex, 10) || 0);
      });
      show(0);
    };
    document.querySelectorAll('[data-anipura-loved]').forEach(initLoved);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-anipura-loved]').forEach(initLoved));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProduct = (section) => {
      if (section.dataset.productReady) return;
      section.dataset.productReady = 'true';
      const money = (cents) => {
        const value = cents / 100;
        if ((section.dataset.currency || '').toUpperCase() === 'THB') return `฿${new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2 }).format(value)}`;
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:section.dataset.currency, minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2 }).format(value); }
        catch (_) { return value.toFixed(Number.isInteger(value) ? 0 : 2); }
      };
      const mediaItems = [...section.querySelectorAll('[data-product-media]')];
      const thumbnails = [...section.querySelectorAll('[data-product-thumbnail]')];
      const selectMedia = (thumbnail) => {
        if (!thumbnail) return;
        const id = thumbnail.dataset.productThumbnail;
        mediaItems.forEach((item) => { const active = item.dataset.productMedia === id; item.hidden = !active; item.classList.toggle('is-active', active); if (!active) item.querySelectorAll('video').forEach((video) => video.pause()); });
        thumbnails.forEach((item) => { const active = item === thumbnail; item.classList.toggle('is-active', active); if (active) item.setAttribute('aria-current','true'); else item.removeAttribute('aria-current'); });
        thumbnail.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'center' });
      };
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => selectMedia(thumbnail)));
      section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
        const index = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
        selectMedia(thumbnails[(index - 1 + thumbnails.length) % thumbnails.length]);
      });
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
        const index = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
        selectMedia(thumbnails[(index + 1) % thumbnails.length]);
      });
      const allVideos = [...section.querySelectorAll('video')];
      allVideos.forEach((video) => video.addEventListener('play', () => allVideos.forEach((other) => { if (other !== video && !other.paused) other.pause(); })));
      const variantSelect = section.querySelector('[data-product-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const discount = section.querySelector('[data-product-discount]');
      const addButton = section.querySelector('[data-product-add]');
      const addLabel = addButton?.querySelector('span');
      const addPrice = addButton?.querySelector('[data-add-price]');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const quantityOptions = section.querySelector('[data-quantity-options]');
      const quantityInput = section.querySelector('[data-quantity-input]');
      const quantityOutput = section.querySelector('[data-quantity-output]');
      const quantityDecrease = section.querySelector('[data-quantity-decrease]');
      const quantityIncrease = section.querySelector('[data-quantity-increase]');
      const bundleChoices = [...section.querySelectorAll('[data-bundle-choice]')];
      const currentUnitPrice = () => Number.parseInt(variantSelect?.selectedOptions[0]?.dataset.priceCents || quantityOptions?.dataset.unitPrice || '0', 10);
      const selectedQuantity = () => Number.parseInt(quantityInput?.value || '1', 10);
      const discountAmountForQuantity = (quantity) => {
        if (quantity >= 3) return Number.parseInt(quantityOptions?.dataset.packThreeDiscountAmount || '0',10);
        if (quantity === 2) return Number.parseInt(quantityOptions?.dataset.packTwoDiscountAmount || '0',10);
        return 0;
      };
      const previewUnitPrice = (quantity) => Math.max(0,currentUnitPrice() - discountAmountForQuantity(quantity));
      const updateQuantityTotals = () => {
        section.querySelectorAll('[data-quantity-total]').forEach((node) => {
          const quantity = Number.parseInt(node.dataset.quantityTotal,10);
          node.textContent = `Total ${money(previewUnitPrice(quantity) * quantity)}`;
        });
        section.querySelectorAll('[data-quantity-per-bottle]').forEach((node) => {
          const quantity = Number.parseInt(node.dataset.quantityPerBottle,10);
          node.textContent = `${money(previewUnitPrice(quantity))}${quantity > 1 ? ' per bottle' : ''}`;
        });
        const quantity = selectedQuantity();
        const total = money(previewUnitPrice(quantity) * quantity);
        if (mobilePrice) mobilePrice.textContent = total;
        if (addPrice) addPrice.textContent = total;
      };
      const setQuantity = (nextQuantity) => {
        const quantity = Math.max(1,Math.min(99,Number.parseInt(nextQuantity,10) || 1));
        if (quantityInput) quantityInput.value = String(quantity);
        if (quantityOutput) quantityOutput.textContent = String(quantity);
        if (quantityDecrease) quantityDecrease.disabled = quantity <= 1;
        bundleChoices.forEach((choice) => { choice.checked = Number.parseInt(choice.value,10) === quantity; });
        updateQuantityTotals();
      };
      bundleChoices.forEach((choice) => choice.addEventListener('change', () => { if (choice.checked) setQuantity(choice.value); }));
      quantityDecrease?.addEventListener('click', () => setQuantity(selectedQuantity() - 1));
      quantityIncrease?.addEventListener('click', () => setQuantity(selectedQuantity() + 1));
      if (variantSelect && price && compare && addButton) variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const unitPrice = Number.parseInt(option.dataset.priceCents || '0',10);
        const comparePrice = Number.parseInt(option.dataset.compareCents || '0',10);
        price.textContent = option.dataset.price;
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        if (discount) {
          const discountPercent = comparePrice > unitPrice ? Math.round(((comparePrice - unitPrice) / comparePrice) * 100) : 0;
          discount.hidden = discountPercent <= 0;
          discount.textContent = discountPercent > 0 ? `Save ${discountPercent}%` : '';
        }
        addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
        if (addPrice) addPrice.hidden = !available;
        if (mobileAdd) { mobileAdd.disabled = !available; mobileAdd.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel; }
        updateQuantityTotals();
      });
      setQuantity(selectedQuantity());
      const productForm = section.querySelector('.anipura-pdp__form');
      productForm?.addEventListener('submit', async (event) => {
        if (!window.AnipuraCart || addButton?.disabled) return;
        event.preventDefault();
        addButton.disabled = true;
        addButton.setAttribute('aria-busy','true');
        if (addLabel) addLabel.textContent = 'Adding…';
        try {
          await window.AnipuraCart.add(productForm);
        } catch (error) {
          if (addLabel) addLabel.textContent = error.message || 'Try again';
        } finally {
          addButton.disabled = false;
          addButton.removeAttribute('aria-busy');
          window.setTimeout(() => { if (addLabel) addLabel.textContent = addButton.dataset.addLabel; }, 1200);
        }
      });
      const timer = section.querySelector('[data-promo-timer]');
      if (timer) {
        const end = Date.parse(timer.dataset.end);
        const output = timer.querySelector('[data-timer-output]');
        if (Number.isFinite(end) && end > Date.now()) {
          timer.hidden = false;
          const tick = () => {
            const remaining = end - Date.now();
            if (remaining <= 0) { timer.hidden = true; return; }
            const days = Math.floor(remaining / 86400000);
            const hours = Math.floor((remaining % 86400000) / 3600000);
            const minutes = Math.floor((remaining % 3600000) / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            output.textContent = `${days}d ${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
            window.setTimeout(tick,1000);
          };
          tick();
        }
      }
    };
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-product-section]').forEach(initProduct));
  })();

  } catch(e) { console.error(e); }
})();
})();
